import { render, staticRenderFns } from "./TopupDisbursement.vue?vue&type=template&id=2beef696"
import script from "./TopupDisbursement.vue?vue&type=script&lang=js"
export * from "./TopupDisbursement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports